import {NgModule} from '@angular/core';


import {EffectsModule} from '@ngrx/effects';
import {StoreModule} from '@ngrx/store';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';

import {mainReducer} from './reducers/index';
import {UserEffects} from './effects/user.effects';


const appEffectsRun = [
  EffectsModule.run(UserEffects)
]



@NgModule({
  imports: [
    StoreModule.provideStore(mainReducer),
    appEffectsRun,
    StoreDevtoolsModule.instrumentOnlyWithExtension()
  ]
})
export class MainStateModule {


}



// WEBPACK FOOTER //
// ./src/main/angular/app/main-state/main-state.module.ts